<template>
  <donut-chart-card
    title="원료·제조물 사업장 예산 집행률 현황"
    :value="data"
    unit="건"
    :isMoveWrite="isMoveWrite"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'
import CircleGraphUtil from '@/util/CircleGraphUtil'
export default {
  name: 'DonutChart26',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    }
  },
  watch: {
    dataType (value) {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 26,
      boardIds: [311, 317, 337],
      summaryKeys: {
        'detail' : ['안전계획_종류', 'count'],
        'field' : ['안전계획_사업장명', 'count'],
        'address' : ['안전계획_종류', 'count'],
        'field_cat1' : ['안전계획_종류', 'count'],
        'company' : ['안전계획_종류', 'count'],
        'project' : ['안전계획_종류', 'count'],
      },
      data: [{label: '데이터 없음', value: 0}],
    }
  },
  async mounted () {
    await this.loadGraph()
  },
  methods: {
    async loadGraph () {
      const projectIds = this.projectId ? [this.projectId] : []
      const summaryKey = this.summaryKeys[this.dataType]
      const boardIds = this.boardIds
      const dataType = this.dataType
      console.log('donut26', projectIds, boardIds, summaryKey, dataType);
      const dataList = await CircleGraphUtil.loadGraphPieces(this.$store, projectIds, boardIds, summaryKey, dataType)
      let value = {}
      for (const data of dataList) {
        value = CircleGraphUtil.combineCircleGraphData(value, data)
      }
      this.data = CircleGraphUtil.circleModuleWithData(value)
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
